interface quicklinks {
  id: number;
  title: string;
  link: string;
  requiresIPD?: boolean;
}

export const buildHeaderMenu = (isIPDEnabled: boolean): quicklinks[] => {
  const menus: quicklinks[] = [
    { id: 1, title: 'LABEL.DASHBOARD', link: '/dashboard' },
    { id: 2, title: 'LABEL.PATIENTS', link: '/patient' },
    { id: 3, title: 'LABEL.APPOINTMENTS', link: '/appointment' },
    { id: 4, title: 'ENTITY.PHARMACY', link: '/pharmacy' },
  ];

  if (isIPDEnabled) {
    menus.push({
      id: 5,
      title: 'ENTITY.IPD',
      link: '/ipd/management',
    });
  }

  return menus;
};
